import { Component, OnInit, OnDestroy, ChangeDetectorRef, OnChanges, SimpleChanges, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router, Data } from "@angular/router";
import { Location } from "@angular/common";
import * as jp from "jsonpath/jsonpath";
import { from as observableFrom, of as observableOf, Observable, Subscription, Subject, BehaviorSubject, forkJoin } from 'rxjs';
import { tap, map, mergeMap, finalize } from "rxjs/operators";
import { GenerateReportModel } from "../../../reports/model/reports.model";
import { AuthService } from "../../../services/auth.service";
import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../core/models/dialog.model";
import { FlowButtonOverrideService } from "../../services/flow-button-override.service";
import { FlowInstanceService } from "../../services/flow-instance.service";
import { LayoutService } from "../../../layouts/services/layout.service";
import { LoaderService } from "../../../common/services/loader.service";
import { NoteService } from "../../../common/services/note.service";
import { SidePanelService } from "../../../common/services/side-panel.service";
import { SubHeaderService } from "../../../core/services/sub-header.service";
import { RuleBuilderService } from "../../../builder/services/rule-builder.service";
import { RuleCompiler } from "../../services/rule-compiler.service";
import { AddReviewerButton, ApproveButton, Button, ButtonKind, ButtonPosition, FlowInstance, Page, PageJumpButton, PageType, Question, QuestionKind, ReturnButton, Section, SectionJumpButton, State, Transition, TransitionButton, UpdateWorkItemButton } from "../../models/flow.model";
import { NoteType } from "../../../common/models/note-type.enum";
import { SidePanel } from "../../../common/models/side-panel.model";
import { StateType, NavigationRecord, FlowIndex, FlowHistory, EntryType, HistoryType } from "../../../common/models/flow.dto";
import StaticPromise from "../../../common/models/static-promise";
import { SubHeader } from "../../../core/models/sub-header.model";
import { UserIdentity } from "../../../models/user-identity.model";
import { WorkOrder, WorkOrderType, WorkOrderStatus } from "../../../common/models/work-order.model";
import { FlowHistoryService } from "../../services/flow-history.service";
import { ApplicationConfigService, ModuleConfig } from "../../../services/application-config.service";
import { SystemSetting, SystemSettingSearchSpec, SettingNames } from "../../../admin/models/system-setting.model";
import { SystemSettingsService } from "../../../admin/services/system-settings.service";

enum TransitionButtionClickAction {
    None = 1,
    TransitionExecuting = 2,
    TransitionNotExecuting = 3
}

@Component({
    selector: "flow",
    templateUrl: "./flow.component.html",
    styleUrls: ["./flow.component.scss"],
    providers: [
        FlowButtonOverrideService
    ],
    standalone: false
})
export class FlowComponent implements OnInit, OnDestroy, OnChanges {

    public _onFormGenerated: Subject<FormGroup> = new Subject();
    get onFormGenerated() { return this._onFormGenerated.asObservable(); }
    private absolutePageIndex: number = 0;
    public activeSidePanel: SidePanel;
    public addAdhoc: boolean = false;
    public clickedButton: Button;
    public currentPageIndex: number;
    public currentSectionIndex: number;
    enableNavigationTracking: boolean = false;
    public flowForm: FormGroup;
    infiniteLoop: boolean = false;
    infiniteLoopDetected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    infiniteLoopMessage: string = "";
    public ngForm: FormGroup;
    public page: Page;
    public pageTitle: string;
    
    public section: Section;
    public sectionContext: any;
    public state: State;
    public workflow: FlowInstance;
    public workItemId: string;
    public returningUser: boolean = true;
    public showNavigationButtons: boolean = true;
    public subscriptions = new Subscription();
    public disableNavigation: boolean = false;
    public buttonIsLocked: boolean = false;
    public url: string = '';

	private _flowIndex: FlowIndex | null = null;
	public moduleConfig?: ModuleConfig;
	public expediteSetting?: SystemSetting;

	get acceptingExpedites(): boolean {
		return this.expediteSetting != null && this.expediteSetting.isActive;
	}

	get showExpediteMessage(): boolean {
		return this.moduleConfig != null && this.moduleConfig.expediteFees != null && this.workflow != null && this.moduleConfig.expediteFees.flowsWithExpediting.findIndex(f => this.workflow.templateId.startsWith(f)) != -1;
	}


    public get currentFlowIndex(): FlowIndex | null { return this._flowIndex; }
    public set currentFlowIndex(value: FlowIndex | null) {
        this._flowIndex = value;
        if (this._flowIndex != null) this.subHeaderService.updateSubHeader(this.setSubheader());
    }

    protected indexSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    get indexLoaded(): boolean {
        return this.indexSubject.value;
    }

    _navigation = new EventEmitter<NavigationRecord>();
    private summaryNextButton?: PageJumpButton;    

    public sidePanelWithFieldNotes: SidePanel = new SidePanel({
        tabs: [{ title: "Field Notes", stateTypeRequired: StateType.ReviewForm }, { title: "Review Notes", stateTypeRequired: StateType.ReviewForm }, { title: "History", stateTypeRequired: StateType.ReviewForm }],
        sections: [{ componentName: 'FieldNotes' }, { componentName: 'ReviewNotes' }, { componentName: 'History' }]
    });
    public sidePanelWithoutFieldNotes: SidePanel = new SidePanel({
        tabs: [{ title: "Review Notes", stateTypeRequired: StateType.ReviewForm }, { title: "History", stateTypeRequired: StateType.ReviewForm }],
        sections: [{ componentName: 'ReviewNotes' }, { componentName: 'History' }]
    });

    completeDialog: Dialog = new Dialog("<<complete message>>", [new DialogButton("Exit", true, () => this.onComplete())]);
    confirmDialog: Dialog = new Dialog("Are you sure you want to <<message>>?", [new DialogButton("Confirm", true, () => this.confirmButtonAction()), new DialogButton("Cancel", false, () => this.onDialogClose())]);
    forbiddenDialog: Dialog = new Dialog("<<forbid message>>", [new DialogButton("Exit", false, () => this.routeForbidden())]);
    missingInformationDialog: Dialog = new Dialog("<h2>Required Information Missing!</h2> <p>You have missing information on this page.  You may complete this information now or you may continue on with the form.  You will be required to complete this information before submitting the form.</p>", [new DialogButton("Continue", true, () => this.missingInformationContinue()), new DialogButton("Cancel", false, () => this.onDialogClose())]);
    notifyDialog: Dialog = new Dialog("<<notification>>", [new DialogButton("Exit", false, () => this.onDialogClose())]);
    restrictedDialog: Dialog = new Dialog("In order to complete this submission, an agent with Executive Authority or Authorized Agents permissions must perform the additional steps necessary.", [new DialogButton("OK", false, () => { return false; })]);

    printPdfButton: any = { name: "Save as PDF", method: () => this.printPdf() };

    printSpecificStyles: string[] = ["button { display: none !important; }", ".small-12, .medium-12, .large-12 { width: 100% !important; } li div.grid-x { display: flex !important; }", ".small-6, .medium-6, .large-6 { width: 50% !important; }", ".screen-only { display: none !important; visibility: hidden !important; max-height: 0 !important; }", ".popover-content { display: none; }", "label { display: inline !important; }", ".bold { font-weight: bold; }", ".section-heading { background-color: #dddddd !important; } .show-for-sr { display: none !important; }", ".question-row { display: flex !important; flex-direction: row !important; }", ".question-cell { align-items: top !important; flex: 1 1 0% !important; margin: 0.5rem !important; position: relative !important; flex-wrap: wrap !important; }", "p br { display: none !important; content: ' ' !important; } p br:after { content: ' ' !important;  }", "svg-icon { display: none !important; }", ".grid-x { display: flex !important; flex-flow: row wrap; } .cell { flex: 0 0 auto; min-height: 0; min-width: 0; width: 100%; } .align-self-center { align-self: center; } .flex-grow-1 { flex: 1 1 0%; } .flex { display: flex !important; } .align-items-center { align-items: center !important; } .no-list-style { list-style: none !important; padding-left: 0 !important; }", "table.print-only { display: table !important; width: 100% !important; }" ];
    iconPrintStyles: string = "svg-icon svg { height: 24px !important; width: 24px: !important; vertical-align: middle !important; pointer-events: none !important; } svg-icon.x-large svg { width: 36px !important; height: 36px !important } svg-icon.small svg { width: 20px !important; height: 20px !important; } svg-icon.tiny svg { width: 14px !important; height: 14px !important; } svg-icon.white { fill: white !important; } svg-icon.error { fill: #b63e23 !important; } svg-icon.medium-gray { fill: #767676: !important } svg-icon.dark-gray { fill: #2d3940 !important; } svg-icon.green { fill: green !important; } svg-icon.light-blue { fill: #098BBC !important; }";
    checkboxPrintStyles: string = ".checkbox {	display: flex;	padding: 1.5rem;	border: solid 1px #098BBC;	background-color: #098BBC;	filter: brightness(125%);}.checkbox input[type=\"checkbox\"] {	line-height: 1.5rem;}.checkbox input[type=\"checkbox\"] .flex-row label {	display: flex;	align-items: center;}.checkbox input[type=\"checkbox\"] .flex-row label	.checkbox-box {	display: flex;	align-items: center;	margin-right: 0.75rem;	background-color: #FDFDFD;	border: solid 1px #DDDDDD;}.checkbox input[type=\"checkbox\"] &:checked .flex-row label .checkbox-box .checkbox-check {	visibility: visible;}";
    @ViewChild("container") public pageContainer?: ElementRef<HTMLDivElement>;
    @ViewChild("downloadLink") public downloadLink?: ElementRef<HTMLAnchorElement>;

    get isReadOnly(): boolean {
        return false;
    }

    get isReviewForm(): boolean {
        if (this.state == null) return false;
        return this.state.stateType == StateType.ReviewForm;
    }

    get title(): string {
        let value = (this.workflow == null) ? "" : this.workflow.name;
        if (this._flowIndex != null) {
            let applicationNumber: string = (this._flowIndex as any).applicationNumber;
            if (applicationNumber == null) applicationNumber = this._flowIndex.flowIdentifier;
            if (applicationNumber != null) value = `${value} - ${applicationNumber}`;
        }
        if (value == null) {
            value = "";
        }
        if (this.isReadOnly) value = `${value} ** READ ONLY **`;
        return value;
    }

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public location: Location,
        public subHeaderService: SubHeaderService,
        public noteService: NoteService,
        public dialogService: DynamicDialogService,
        public layoutService: LayoutService,
        public sidePanelService: SidePanelService,
        public flowOverrideService: FlowButtonOverrideService,
        public readonly authService: AuthService,
        public readonly changeDetector: ChangeDetectorRef,
        public readonly loaderService: LoaderService,
        public readonly flowInstanceService: FlowInstanceService,
        public readonly ruleBuilder: RuleBuilderService,
        public readonly ruleCompiler: RuleCompiler,
		public readonly historyService: FlowHistoryService,
		protected readonly _configService: ApplicationConfigService,
		protected readonly _settings: SystemSettingsService
    ) { }

    ngOnInit() {
        this.flowOverrideService.flow = this;
        this.buttonIsLocked = false;
        const routeData$: Observable<Data> = this.route.data.pipe(
            tap((data: Data) => {
                if (!data.workflow) {
                    console.error("No data available for render; routing home");
                    this.router.navigate(["/home"]);
                }
                if (data.workflow.toString() === data.workflow) {
                    this.forbid(data.workflow);
                } else {
                    let routeWorkItemId = this.route.snapshot.params.workItemId;
                    let routeWorkflow: FlowInstance = data.workflow;
                    if (routeWorkflow.onBehalf && routeWorkItemId == null) { //re-route non-review on-behalf flows to the on-behalf renderer
                        let reRoute: string = `/flow/on-behalf/${routeWorkflow.id}`;
                        this.router.navigate([reRoute]);
                    }
                    //IF they're coming in from create, or resuming a flow that hasn't actually had anything done to it, where it's configured not to take you to summary page
                    //don't mark it as a returning user.
                    if (this.route.snapshot.url[0].path === "create" ||
                        (!data.workflow.startAtSummary && (!data.workflow.context.navigations || !(data.workflow.context.navigations.length > 0)))) {
                        this.location.replaceState("/flow/" + routeWorkflow.id);
                        this.returningUser = false;
                    };
                    this._loadWorkflow(routeWorkflow, routeWorkItemId);
                }
            })
        );

		let indexObs$: Observable<FlowIndex | null> = observableOf(null);

		let configObs$: Observable<any> = this._configService.getModuleConfig().pipe(
			tap((conf: ModuleConfig) => {
				this.moduleConfig = conf;
			}),
			mergeMap(() => {
				let spec: SystemSettingSearchSpec = {
					settingName: SettingNames.AllowExpedite
				}
				return this._settings.search(spec).pipe(
					tap((settings: SystemSetting[]) => {
						if (settings != null && settings.length > 0) {
							this.expediteSetting = settings.find(s => s.settingName === SettingNames.AllowExpedite);
						}
					})
				)
			})
		);

				

        if (this.route.snapshot.url[0].path !== "create") {
            let flowId = this.route.snapshot.params["id"];
            indexObs$ = (flowId != null && flowId.length > 0)
                ? this.flowInstanceService.findFlowIndex(flowId).pipe(
                    tap((idx: FlowIndex) => { this.currentFlowIndex = idx; })
                )
                : observableOf(null);
        }

        indexObs$ = indexObs$.pipe(finalize(() => { this.indexSubject.next(true); }));

		const subs$ = forkJoin([routeData$, indexObs$, configObs$]).subscribe(
            (data: any) => { },
            (error) => { console.error(error); }
        );
        this.subscriptions.add(subs$);

        let noteAdded$ = this.noteService.noteAdded$.asObservable().pipe(
            mergeMap((note) => {
                const obs$ = (this.workflow != null) ? this.saveNoteEvent() : observableOf(note);
                return obs$;
            }))
            .subscribe((note) => {
                this.changeDetector.detectChanges();
            },
                (error) => { console.error(error); }
            );
        this.subscriptions.add(noteAdded$);
    }

    public _loadWorkflow(routeWorkflow: FlowInstance, routeWorkItemId: string): void {
        this.workflow = routeWorkflow;
        this.workItemId = routeWorkItemId;
        this.state = this.workflow.findCurrentState();
        this.enableNavigationTracking = this.state.stateType === StateType.InputForm; //only track navigation for the submission, not the reviewer(s)
        if (this.enableNavigationTracking) {
            const navigationSubscription = this._navigation.pipe(tap((data) => {      
                if (!this.returningUser) {
                    this.workflow.context.navigations.push(data);
                } else {
                    this.returningUser = false;
                }               
            })).subscribe((data) => {

            }, (error) => {
                console.error(error);
            });
            this.subscriptions.add(navigationSubscription);
        }
        this.resetSidePanels();
        

        this.goToInitialPage();
        this.layoutService.update("FlowComponent");

        if (this.workflow.currentWorkItem) {
            
            this.activeSidePanel = this.sidePanelWithoutFieldNotes;
            this.activeSidePanel.tabs = this.activeSidePanel.tabs.filter(t => !t.stateTypeRequired || t.stateTypeRequired === this.state.stateType);
            this.sidePanelService.newSidePanel(this.activeSidePanel); //Ensures that the side panel is properly initialized to be the notes side panel
        }
        this.subHeaderService.updateSubHeader(this.setSubheader());
    }

    resetSidePanels(): void {
        this.sidePanelWithoutFieldNotes = new SidePanel({
            tabs: [{ title: "Review Notes" }, { title: "Timeline", stateTypeRequired: StateType.ReviewForm }],
            sections: [{ componentName: 'ReviewNotes', componentData: this.workflow.context }, { componentName: 'History' }]
        });
        this.sidePanelWithFieldNotes = new SidePanel({
            tabs: [{ title: "Field Notes" }, { title: "Review Notes" }, { title: "Timeline", stateTypeRequired: StateType.ReviewForm }],
            sections: [{ componentName: 'FieldNotes' }, { componentName: 'ReviewNotes', componentData: this.workflow.context }, { componentName: 'History' }]
        });
        this.activeSidePanel = this.sidePanelWithoutFieldNotes;
        this.activeSidePanel.tabs = this.activeSidePanel.tabs.filter(t => !t.stateTypeRequired || t.stateTypeRequired === this.state.stateType);
        this.sidePanelService.newSidePanel(this.activeSidePanel);
    }

    ngOnDestroy() {
        if (this.subscriptions)
            this.subscriptions.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.changeDetector.detectChanges();
    }

    setSubheader(): SubHeader {
        const subheader = new SubHeader({ title: this.title, buttons: [] });
        if (this.workflow.currentWorkItem != null) {
            const buttonName = this.state.stateType === StateType.InputForm ? "View Notes" : "View Notes & Timeline";
            subheader.buttons.push({ name: buttonName, method: () => this.addFlowNote() });
        }
        let summaryRow = this.page.questions.find(r => r.find(q => q.type === QuestionKind.Summary));
        if (summaryRow != null) {
            let summaryQuestion: Question = summaryRow.find(r => r.type === QuestionKind.Summary);
            if (summaryQuestion != null) {
                subheader.buttons.push(this.printPdfButton);
            }
        }       
        return subheader;
    }

    public addFlowNote(): void {
        this.noteService.newNote({ data: jp.value(this.workflow.context, "$.flowNotes"), reviewNotes: jp.value(this.workflow.context, "$.reviewNotes"), instance: this.workflow, stateType:  this.state.stateType });
        this.activeSidePanel = this.sidePanelWithoutFieldNotes;
        this.activeSidePanel.tabs = this.activeSidePanel.tabs.filter(t => !t.stateTypeRequired || t.stateTypeRequired === this.state.stateType);
        this.sidePanelService.newSidePanel(this.activeSidePanel);
        this.sidePanelService.toggleSidePanel(true);
    }

    public addQuestionNote(contextTarget: string): Observable<boolean> {
        if (!contextTarget) {
            console.warn(`Missing Context Target Configuration.  Cannot create a note.`);
            return;
        }

        let obs = this.noteService.newNote({
            data: jp.value(this.workflow.context, contextTarget),
            reviewNotes: jp.value(this.workflow.context, "$.reviewNotes"),
            instance: this.workflow,
            stateType: this.state.stateType
        });
        this.activeSidePanel = this.sidePanelWithFieldNotes;
        this.activeSidePanel.tabs = this.activeSidePanel.tabs.filter(t => !t.stateTypeRequired || t.stateTypeRequired === this.state.stateType);
        this.sidePanelService.newSidePanel(this.activeSidePanel);
        this.sidePanelService.toggleSidePanel(true);
        return obs;
    }

    public buttonClick(button: Button): void {
        this.clickedButton = button;
        if (this.restrictButtonAccess(button)) {
            this.restrictedDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.restrictedDialog);
        } else if (button.confirmAction) {
            this.confirmDialog.toggleDialog(true);
            this.confirmDialog.message = `Are you sure you want to ${button.label}?`;
            this.dialogService.updateDialog(this.confirmDialog);
        } else {
            this.buttonAction(this.clickedButton);
        }
       
    }

    public buttonAction(button: Button): any {
        this.loaderService.reset(); //resets the loader to void out any timers
        if (button.isNavigation) {
            this._navigation.emit({ section: this.currentSectionIndex, page: this.currentPageIndex, absolutePageIndex: this.absolutePageIndex } as NavigationRecord);
        }

        if (button.isTransition) {
            this.buttonIsLocked = true;
        }

        let workItem: WorkOrder;
        if (this.workItemId) {
            workItem = this.workflow.associatedWorkItems.find(wi => wi.id === this.workItemId);
        }

        let parentWorkItem: WorkOrder;
        if (workItem && workItem.parentTaskId) {
            parentWorkItem = this.workflow.associatedWorkItems.find(wi => wi.id === workItem.parentTaskId);
        }

        if (button.isApprove) {
            (button as ApproveButton).targetTransition = (): Promise<string> => {
                const transition = (workItem.type === WorkOrderType.AdHocReview) ? "" : workItem.transition;
                return observableOf(transition).toPromise();
            };
        }

        if (button.isReturn) {
            const destination = (button as ReturnButton).finalDestination();
            if (workItem.parentTaskId && parentWorkItem && parentWorkItem.type != WorkOrderType.Resubmit) {
                (button as ReturnButton).targetTransition = (): Promise<string> => {
                    return observableOf(workItem.parentTaskId).toPromise();
                }
            } else {
                const transition = (workItem.type === WorkOrderType.AdHocReview) ? "" : destination;
                (button as ReturnButton).targetTransition = (): Promise<string> => {
                    return observableOf(transition).toPromise();
                }
            }
        }

        if (button.isTransition) {
            const transitionButton = button as TransitionButton;
            transitionButton.targetTransition().then(targetTransition => {
                let transition: Transition = undefined;
                let previousWorkItem: WorkOrder = undefined;
                let targetState: State;
                if (targetTransition !== "") {
                    transition = this.state.transitions.find(x => x.name === targetTransition || x.key === targetTransition);
                    if (transition) {
                        targetState = this.workflow.states.find(s => s.name === transition.targetState);
                    } else {
                        previousWorkItem = this.workflow.associatedWorkItems.find(wi => wi.id === targetTransition);
                        if (!previousWorkItem) {
                            console.error(`Transition ${targetTransition} not found.`);
                            return;
                        }
                    };
                }

                if (transition) {
                    Promise.all(transition.outgoingRules.map(x => x.rule()))
                    .then(values => values.forEach((value, i) => jp.value(this.workflow.context, transition.outgoingRules[i].contextTarget, value)))
                    .then(x => this.determineExecution(button, transition))
                    .then(doExecute => {
                        if (doExecute) {
                            this.loaderService.toggleLoader(true);
                                observableFrom(this.workflow.executeTransition(this.state, transitionButton, transition)).subscribe(qq => {
                                        const homeString = "/home";
                                        let redirectTarget = qq;
                                if (redirectTarget && redirectTarget.length > 0 && redirectTarget != homeString) {
                                       if (this.isSelfRedirect(redirectTarget)) {
                                        this.flowInstanceService.getByWorkItem(this.workflow.id, this.workItemId).subscribe(f => {
                                            this._loadWorkflow(f, this.workItemId);
                                            this.loaderService.toggleLoader(false);
                                        }, (error) => {
                                            console.error(error);
                                        })
                                    } else {
                                        this.loaderService.toggleLoader(false);
                                        this.router.navigate([redirectTarget]);
                                    }
                                }

                                this.loaderService.toggleLoader(false);
                                if (redirectTarget && redirectTarget.length > 0 && redirectTarget != homeString)
                                    this.completeTransitionButtonAction(TransitionButtionClickAction.None, button, targetState);
                                else
                                    this.completeTransitionButtonAction(TransitionButtionClickAction.TransitionExecuting, button, targetState);
                            }, (error) => {
                                    console.error(error);
                            });
                        } else {
                            this.notify("Request cannot be approved at this time due to additional outstanding tasks.");
                        }
                    });
                } else if (previousWorkItem) {
                    this.promiseSaveContext()
                        .then(x => {
                            return this.determineExecution(button);
                        })
                    .then(doExecute => {
                        if (doExecute) {
                            this.workflow.returnWorkItem(workItem);
                        } else {
                            this.notify("Request cannot be approved at this time due to additional outstanding tasks.");
                        }
                        return doExecute;
                    })
                    .then(x => {
                        if (x) {
                            this.notifyComplete("The request has been returned to the previous reviewer.");
                        } else {
                            this.router.navigate(["/home"]);
                        }
                    });
                } else { //ad hoc review path
                    this.promiseSaveContext()
                        .then(x => {
                        if (button.isApprove) {
                            this.workflow.completeWorkItem(workItem);
                                this.notifyComplete("Review has been approved");
                        } else {
                            this.workflow.returnWorkItem(workItem);
                                this.notifyComplete("Review has been rejected.");
                        }
                    });
                }
            });
        } else if (button.isAddReviewer) {
            this.toggleAdhoc(!this.addAdhoc);
        } else if (button.isSectionJump) {
            const jb = button as SectionJumpButton;
            jb.targetSection().then(sectionNum => {
                this.promiseSaveContext()
                    .then(qq => {
                    this.setPage(sectionNum, 0);
                });
            });
        } else if (button.isUpdateWorkItem) {
            this.promiseSaveContext()
                .then(x => {
                const updateWorkItemButton = button as UpdateWorkItemButton;
                if (updateWorkItemButton.stateToSetWorkItemTo == WorkOrderStatus.Completed) {
                    this.workflow.completeWorkItem(workItem);
                    this.notifyComplete("Review has been approved");
                } else if (updateWorkItemButton.stateToSetWorkItemTo == WorkOrderStatus.Returned) {
                    this.workflow.returnWorkItem(workItem);
                    this.notifyComplete("Review has been rejected.");
                }
            });
        } else {
            if (this.page.partiallyRequiredValid()) {
                this.goToPage(button);
            } else {
                this.missingInformationDialog.toggleDialog(true);
                this.dialogService.updateDialog(this.missingInformationDialog);
            }
        }
    }

    public completeTransitionButtonAction(x: TransitionButtionClickAction, button: Button, targetState: State): void {
        if (x === TransitionButtionClickAction.TransitionExecuting) {
            let notifyMessage = button.notifyMessageRule();
            if (notifyMessage && notifyMessage.length > 0) {
                this.notifyComplete(notifyMessage);
            }
            else if (this.state.stateType === StateType.InputForm && targetState.stateType === StateType.ReviewForm) {
                this.notifyComplete("Your request has been submitted for review.");
            } else if (this.state.stateType === StateType.ReviewForm && targetState.stateType === StateType.ReviewForm && button.isApprove) {
                this.notifyComplete("The request has been submitted for next level review.");
            } else if (this.state.stateType === StateType.ReviewForm && targetState.stateType === StateType.End && button.isApprove) {
                this.notifyComplete("The request has been approved.");
            } else if (this.state.stateType === StateType.ReviewForm && targetState.stateType === StateType.ReviewForm && button.isReturn) {
                this.notifyComplete("The request has been returned to the previous reviewer.");
            } else if (this.state.stateType === StateType.ReviewForm && targetState.stateType === StateType.InputForm) {
                this.notifyComplete("The request has been returned to the original submitter.");
            } else {
                this.router.navigate(["/home"]);
            }
        } else if (x === TransitionButtionClickAction.TransitionNotExecuting) {
            this.router.navigate(["/home"]);
        }
    }

    public isSelfRedirect(redirectTarget: string): boolean {
        return this.location.path() === redirectTarget;
    }

    public goToPage(button: Button): void {
        const jb = button as PageJumpButton;
        this.disableNavigation = true;
        jb.targetPage().then((pageNum) => {
            this.absolutePageIndex = pageNum;
            this.promiseSaveContext()
                .then(qq => {
                let newSectionIndex = -1;
                let newPageNum = pageNum;
                for (let s = 0; s < this.state.sections.length; s++) {
                    if (newPageNum >= this.state.sections[s].pages.length) {
                        newPageNum = newPageNum - this.state.sections[s].pages.length;
                    } else {
                        newSectionIndex = s;
                    }
                    if (newSectionIndex !== -1) break;
                }
                if (newSectionIndex !== -1) {
                    this.currentSectionIndex = newSectionIndex;
                    pageNum = newPageNum;
                }

                this.setPage(this.currentSectionIndex, pageNum);
                this.disableNavigation = false;
            }).catch((error) => {
                console.error(error);
                this.disableNavigation = false
            });
        });
    }

    public canShowNote(question: Question): boolean {
        if (question.type === QuestionKind.Label || !question.contextTarget)
            return false;
        if (this.state.stateType === StateType.ReviewForm)
                    return true;
        const notes = this.getNotes(question.contextTarget);
        return this.state.stateType === StateType.InputForm && notes && notes.length > 0;
    }

    public determineExecution(button: Button, transition: Transition = null): Promise<boolean> {
        let doExecute: boolean = true;
        if (button.isApprove) {
            let currentWorkItem: WorkOrder;
            currentWorkItem = this.workflow.associatedWorkItems.find(wi => wi.id === this.route.snapshot.params.workItemId);

            // Is this the last review in the standard chain?

            //If this is an approve, there's an accompanying transition, check whether that transition takes us to a terminal node
            //let transitionsToTerminalNode: boolean;
            //if (transition) {
            //    let targetState = this.workflow.states.find(a => a.name == transition.targetState);
            //    transitionsToTerminalNode = targetState.isTerminal;
            //}

            //transitionsToTerminalNode was going to be used to determine if we should block
            //but for now the registration flow blocks that since we have review forms with letters after where we want to block
            //maybe later change this calculation to walk the tree and find out if there are any side effects that generate workitems on
            //any of them and use that as the condition, but not now.

            //If there is more than one workitem tied to the workflow, we can only rely on the parentTaskId
            //having been set if the workItems were made via a sidEffect tied to multiple levels of review on one review form.
            //we can't rely on this if there is more than one review form in the flow
            //const childReview = this.workflow.associatedWorkItems.find(wi => wi.parentTaskId === this.workItemId);


            //for now check the workorder flag to block
            if (currentWorkItem.blockOnOtherOutstandingWorkOrders) { //last review in the chain
                for (let i = 0; i < this.workflow.associatedWorkItems.length; i++) {
                    doExecute = (this.workflow.associatedWorkItems[i].id === this.workItemId) || (
                        (this.workflow.associatedWorkItems[i].status !== WorkOrderStatus.Pending &&
                            this.workflow.associatedWorkItems[i].status !== WorkOrderStatus.Waiting &&
                            this.workflow.associatedWorkItems[i].status !== WorkOrderStatus.Returned)
                    );
                    if (!doExecute) break;
                }
            }
        }
        return observableOf(doExecute).toPromise();
    }

    public getMaxValidationCount(questionGroup: Question[]): number {
        return Math.max(0, ...questionGroup.map(q =>
            Math.max(q.pageValidationMessages?.length || 0, q.flowValidationMessages?.length || 0)
        ));
    }

    public getErrors(error: any): Array<any> {
        let retVal: Array<any> = new Array<any>();
        if (error) {
            for (let key of Object.keys(error).filter(x => x.indexOf("__") === -1))
                retVal.push(error[key]);
        }
        return retVal;
    }

    public getNoteIcon(contextTarget: string): string {
        let userId = this.authService.User.id;
        const isInternal = this.authService.User.isInternal;
        if (contextTarget) {
                const notes = this.getNotes(contextTarget);
            if (notes && notes.length > 0) {
                var noteAdm = notes.findIndex(x => x.createdById === userId && x.type === NoteType.Administrative);
                var noteReg = notes.findIndex(x => x.type !== NoteType.Administrative);
                var noteGeneral = notes.findIndex(x => x.type === NoteType.General);
                if (isInternal)
                    return noteAdm != -1 ? 'icon-notepad-alert' : noteReg != -1 ? 'icon-notepad-alert' : 'icon-notepad';
                else if (!isInternal && noteGeneral !== -1)
                    return 'icon-notepad-alert';
            } else if (isInternal) {
                return 'icon-notepad';
            }
        }
    }

    getNotes(target: string): any[] {
        let notes = [];
        if (target != null) {
            const data = jp.value(this.workflow.context, target);
            if (data && data["notes"]) notes = data["notes"];
        }       
        return notes;
    }

    public navigateSection(section: Section): void {
        const sectionIndex = this.state.sections.findIndex(x => x.name === section.name);
        this.setPage(sectionIndex, 0);
    }

    public goToInitialPage(): void {
        let workItem: WorkOrder;
        if (this.route.snapshot.params.workItemId) {
            workItem = this.workflow.associatedWorkItems.find(wi => wi.id === this.route.snapshot.params.workItemId);
            if (workItem && workItem.type == WorkOrderType.AdHocReview) {
                var desiredState = this.workflow.states.find(state => state.name == workItem.flowTargetState);
                this.state = desiredState;
            }
        }

        let pageIndex = 0;
        let sectionIndex = 0;
        const goToSpecific: boolean = this.route.snapshot.params.section && this.route.snapshot.params.page;
        if (goToSpecific) {
            sectionIndex = parseInt(this.route.snapshot.params.section, 10);
            pageIndex = parseInt(this.route.snapshot.params.page, 10);
        } else { 
            sectionIndex = this.state.sections.findIndex(s => s.pages.find(p => p.pageType === PageType.Summary) !== undefined);          
        }
            
        //Looks like this was a trial balloon of sorts to try and catch a heisenbug, but doesn't seem like it will hurt
        //so leaving it.
        if (sectionIndex === -1) sectionIndex = 0;
        if (pageIndex === -1) pageIndex = 0;

        if (!goToSpecific) {
            if (this.returningUser && this.workflow.startAtSummary || (!this.workflow.startAtSummary && this.workflow.context.navigations && this.workflow.context.navigations.length > 0)) {
                pageIndex = this.state.sections[sectionIndex].pages.findIndex(p => p.pageType === PageType.Summary);
                if (pageIndex === -1) pageIndex = 0;
            }
            //This is needed to make sure that on first launch, where we are not a returning user
            //the flow starts at the beginning.
            else sectionIndex = 0;
        }
        this.section = this.state.sections[sectionIndex];
        this.absolutePageIndex = 0;
        
        for (let p = 0; p <= sectionIndex; p++) {
            if (p === sectionIndex) {
                this.absolutePageIndex = this.absolutePageIndex + pageIndex;
            } else {
                this.absolutePageIndex = this.absolutePageIndex + this.state.sections[sectionIndex].pages.length;
            } 
        }
        this.setPage(sectionIndex, pageIndex);
    }

    pinToTop(): void {
        const head = document.getElementById("scroll-head");
        if (head)
            head.scrollTop = 0;
    }

    public printPdf(): void {
        if (this.pageContainer != null) {
            let element: HTMLDivElement = this.pageContainer.nativeElement;
            let styles = document.getElementsByTagName("style");
            let html = "";

            // Collect Angular component-scoped <style> tags and strip only the Angular
            // emulated-encapsulation attribute selectors ([_ngcontent-xxx], [_nghost-xxx])
            // so the rules apply globally in IronPdf. Using a targeted regex avoids the
            // off-by-one character-drop from the previous while-loop approach, and avoids
            // stripping legitimate attribute selectors (e.g. input[type="text"]).
            for (let i = 0; i < styles.length; i++) {
                let styleHtml = styles[i].outerHTML.replace(/\[_ng(?:content|host)-[^\]]+\]/g, '');
                html = `${styleHtml}${html}`;
            }

            if (this.printSpecificStyles.length > 0) {
                html = `${html}<style>`;
                this.printSpecificStyles.forEach(s => { html = `${html}${s}` });
                html = `${html}</style>`;
            }

            // Start from element.outerHTML (the live DOM serialization) rather than cloneNode(true).
            // Angular Ivy manages styles for [innerHTML]-rendered content through an internal tracking
            // mechanism that IS reflected in the browser's live rendering (and thus in element.outerHTML)
            // but is NOT propagated to cloneNode snapshots or the DOM style attribute at the moment
            // of cloning. Using element.outerHTML as the source preserves those inline styles exactly
            // as they existed before the Angular upgrade. DOMParser creates an independent document
            // so we can manipulate it without affecting the live page.
            const parser = new DOMParser();
            const parsedDoc = parser.parseFromString(element.outerHTML, 'text/html');
            const printElement = parsedDoc.body.firstElementChild as HTMLDivElement;

            // Strip Angular encapsulation attributes from all elements. They served as CSS selector
            // targets in the browser but serve no purpose in IronPdf's rendering context. After the
            // upgrade, Ivy emits longer attribute names (_ngcontent-ng-cXXXXXXXXXX vs. the older
            // _ngcontent-cXXX), and their presence can interfere with Chromium-based rendering.
            (printElement.querySelectorAll('*') as NodeListOf<HTMLElement>).forEach(el => {
                Array.from(el.attributes)
                    .filter(attr => attr.name.startsWith('_ng'))
                    .forEach(attr => el.removeAttribute(attr.name));
            });

            // Stamp inline color styles with !important. After the upgrade, our more-precise Angular
            // selector stripping produces well-formed CSS that IronPdf now applies correctly — including
            // any color !important declarations that the old buggy stripping accidentally mangled. An
            // inline !important declaration (important-author in the cascade) beats any stylesheet rule
            // regardless of specificity, restoring pre-upgrade rendering behavior.
            (printElement.querySelectorAll('[style*="color"]') as NodeListOf<HTMLElement>)
                .forEach(el => {
                    const inlineColor = el.style.color;
                    if (inlineColor) {
                        el.style.setProperty('color', inlineColor, 'important');
                    }
                });

            // summary-item-value: read the computed color and font-weight from a live element
            // and apply them directly. After Angular encapsulation selectors are stripped from
            // the collected CSS, specificity can vary by component order, so an explicit inline
            // rule is more reliable than relying on the cascade.
            const liveValueEl = element.querySelector('.summary-item-value') as HTMLElement | null;
            if (liveValueEl) {
                const liveStyle = getComputedStyle(liveValueEl);
                const valueColor = liveStyle.color;
                const valueFontWeight = liveStyle.fontWeight;
                (printElement.querySelectorAll('.summary-item-value') as NodeListOf<HTMLElement>)
                    .forEach(el => {
                        el.style.setProperty('color', valueColor, 'important');
                        el.style.setProperty('font-weight', valueFontWeight, 'important');
                    });
            }

            (printElement.querySelectorAll('.screen-only') as NodeListOf<HTMLElement>)
                .forEach(el => el.setAttribute('style', 'display:none !important'));
            (printElement.querySelectorAll('.show-for-sr') as NodeListOf<HTMLElement>)
                .forEach(el => el.setAttribute('style', 'display:none !important'));
            (printElement.querySelectorAll('button') as NodeListOf<HTMLElement>)
                .forEach(el => el.setAttribute('style', 'display:none !important'));
            (printElement.querySelectorAll('.print-only') as NodeListOf<HTMLElement>)
                .forEach(el => {
                    // Use setProperty so existing inline styles (e.g. width:100% on the data table)
                    // are preserved. Use the element's natural display type so tables aren't
                    // collapsed to display:block, which breaks column layout.
                    const tag = el.tagName;
                    const displayValue = tag === 'TABLE' ? 'table'
                        : tag === 'THEAD' || tag === 'TBODY' || tag === 'TFOOT' ? 'table-row-group'
                        : tag === 'TR' ? 'table-row'
                        : (tag === 'TD' || tag === 'TH') ? 'table-cell'
                        : 'block';
                    el.style.setProperty('display', displayValue, 'important');
                    el.style.setProperty('visibility', 'visible', 'important');
                });

            const model = new GenerateReportModel();
            model.headerOnFirstPage = false;
            model.footerOnFirstPage = false;
            model.useBanner = false;
            model.usePageNumberHeader = false;
            model.formatAsLetter = false;
            model.html = `${html}${printElement.outerHTML}`;
            model.flowId = this.workflow.id;
            this.loaderService.toggleLoader(true);
            const data$ = this.flowInstanceService.generatePdfSummary(model).pipe(

                )
                .subscribe(
                    (data: any) => {
                        this.loaderService.toggleLoader(false);
                        const blob = new Blob([data], { type: "application/pdf" });
                        const fileName = `${this._flowIndex.flowIdentifier}_Summary.pdf`;
						const url = URL.createObjectURL(blob);
						const link: HTMLAnchorElement = this.downloadLink.nativeElement;
						link.href = url;
						link.download = fileName;
						link.click();
                    },
                    (error) => {
                        console.error(error);
                        this.loaderService.toggleLoader(false);
                        this.dialogService.showError();
                    }
            );
            this.subscriptions.add(data$);
        }
    }

    public setPage(sectionIndex: number, pageIndex: number): any {
        this.disableNavigation = true;

        if (!this.state.sections.length || !this.state.sections[sectionIndex]) {
            this.disableNavigation = false;
            console.warn(`No configured section ${sectionIndex}.`);
            return;
        }       
        this.currentSectionIndex = this.state.sections.findIndex(s => s.id === this.section.id);
        this.section = this.state.sections[sectionIndex];
        if (!this.section.pages.length || !this.section.pages[pageIndex]) {
            this.disableNavigation = false;
            console.warn(`No configured page: Section ${sectionIndex}, Page ${pageIndex}`);
            return;
        }

        this.page = this.section.pages[pageIndex];

        if (!this.workflow.context.sections.find(s => s.id === this.state.sections[sectionIndex].id) && !this.returningUser) {
            this.workflow.context.sections.push(this.state.sections[sectionIndex].id);
        }

        this.currentSectionIndex = sectionIndex;
        this.currentPageIndex = pageIndex;
        this.pageTitle = (this.page.subtitle) ? this.page.subtitle : "";
        this.ngForm = this.page.generateForm(false);
        this._onFormGenerated.next(this.ngForm);
        if (this.enableNavigationTracking && this.page.pageType === PageType.Summary && !this.returningUser) {
            this.reinstateSummaryNextButton();
        } 
        this.subHeaderService.updateSubHeader(this.setSubheader());
        if (this.page.buttons.filter(b => b.isTransition && !b.isReturn && !b.isApprove).length !== 0) {
            let items = {};
            let nextButtons = [];
            const pageCollection = [];
            for (let s = 0; s < this.state.sections.length; s++) {
                for (let p = 0; p < this.state.sections[s].pages.length; p++) {
                    pageCollection.push(this.state.sections[s].pages[p]);
                    const right = this.state.sections[s].pages[p].buttons.find(b => b.position === ButtonPosition.Right);
                    if (right) {
                        nextButtons.push(right);
                    }
                }
            }

            const buttonPromises = nextButtons.map(b => {
                //suspect something may break down here on section jump buttons?
                this.disableNavigation = false;
                if (b.targetPage)
                    return b.targetPage();
                else
                    return StaticPromise.from<number>(() => -1);

            });
            Promise.all(buttonPromises).then(destinations => {                
                let nextPageIndex = 0;
                let pathLog: number[] = [];
                let loopInfinite: boolean = false;
                do {                   
                    if (pathLog.indexOf(nextPageIndex) !== -1) {
                        console.warn("breaking loop before infinite recursion!");    
                        loopInfinite = true;
                        break;
                    }
                    pathLog.push(nextPageIndex);
					const rPage = pageCollection[nextPageIndex];
					if (rPage != null) {
						for (let r = 0; r < rPage.questions.length; r++) {
							const row = rPage.questions[r];
							for (let q = 0; q < row.length; q++) {
								const question = row[q];
								const keyString = `${rPage.section}-${pageIndex}-${question.key}`;
								items[keyString] = question.getFormControl(true);
							}
						}
					}                    
                    nextPageIndex = destinations[nextPageIndex];
                } while (nextPageIndex > 0);
                this.infiniteLoopDetected.next(loopInfinite);
                this.flowForm = new FormGroup(items);
            });
        }

        if (this.enableNavigationTracking && this.page.pageType === PageType.Summary && this.returningUser) {
            this.setSummaryNextButton();
        }

        this.pinToTop();

        Promise.all(this.page.incomingRules.map(x => x.rule()))
        .then(values => {
            values.forEach((value, i) => {
                jp.value(this.workflow.context,
                    this.page.incomingRules[i].contextTarget,
                    value);
            });
        });

        //Check if the current workitem is an adhoc review, we need to set the state back to the one the ad hoc workitem was generated for
        let workItem: WorkOrder;
        if (this.route.snapshot.params.workItemId)
            workItem = this.workflow.associatedWorkItems.find(wi => wi.id === this.route.snapshot.params.workItemId);

        if (workItem && workItem.type == WorkOrderType.AdHocReview) {
            let completeWorkItemButton = new UpdateWorkItemButton(WorkOrderStatus.Completed);
            completeWorkItemButton.label = "Approve";
            completeWorkItemButton.visible = () => true;

            let rejectWorkItemButton = new UpdateWorkItemButton(WorkOrderStatus.Returned);
            rejectWorkItemButton.label = "Return to Previous Reviewer";
            rejectWorkItemButton.visible = () => true;

            let addReviewerButton = new AddReviewerButton();
            addReviewerButton.label = "Add Additional Reviewer";
            addReviewerButton.visible = () => true;

            this.page.specialButtons = [completeWorkItemButton, addReviewerButton, rejectWorkItemButton];
        }

        this.disableNavigation = false;
        this.focusOnFirstInput();
    }

    private focusOnFirstInput(): void {
        setTimeout(() => {
            const inputElements = document.querySelectorAll('input,select');
            if (inputElements && inputElements.length > 0) {
                let firstEl: Element = inputElements[0];
                let focusMe = document.getElementById(firstEl.id);
                if (focusMe) {
                    focusMe.focus();
                }                
            }
        }, 1000);               
    }

    public saveContext(): Observable<any> {
        return this.workflow.saveContext().pipe(tap((index: any) => {
            if (index != null) this.currentFlowIndex = <FlowIndex>index;
        }))
    }

    public saveNoteEvent(): Observable<any> {
        let event: FlowHistory = {
            instanceId: this.workflow.id,
            userId: this.authService.User.id,
            organizationId: this.workflow.organizationId,
            entryType: EntryType.NoteAdded,
            type: HistoryType.Flow
        } as FlowHistory;
        return this.historyService.saveHistory(event).pipe(
            mergeMap((h: any) => {
                return this.saveContext();
                }
            )
        );
    }

    public promiseSaveContext(): Promise<any> {
        return this.saveContext().toPromise();
    }

    setSummaryNextButton(): void {
        let doReplace: boolean = false;
        if (this.workflow.context.navigations && this.workflow.context.navigations.length > 0) {
            doReplace = this.returningUser;
        } else {
            doReplace = true;
            this.workflow.context.navigations = [];
        }
        if (doReplace) {
            let resumeButton: PageJumpButton = new PageJumpButton();
            resumeButton.enabled = (): boolean => { return true; };
            resumeButton.visible = (): boolean => { return true; };
            resumeButton.label = "Resume";
            resumeButton.position = ButtonPosition.Right;
            let lastNavigation = (this.workflow.context.navigations.length > 0)
                ? this.workflow.context.navigations[this.workflow.context.navigations.length - 1] as NavigationRecord
                : { section: 0, page: 0, absolutePageIndex: 0 } as NavigationRecord;
            let resumeDestination: number = lastNavigation.absolutePageIndex;            
            resumeButton.targetPage = (): Promise<number> => { return StaticPromise.of<number>(resumeDestination) };
            let nextIndex = this.page.navigationButtons.findIndex(b => b.type === ButtonKind.Next);
             //no "next" button; see if the "next" button out of the summary is really a jump button
            if (nextIndex === -1) nextIndex = this.page.navigationButtons.findIndex(b => b.type === ButtonKind.JumpToPage && b.position === ButtonPosition.Right);
            if (nextIndex !== -1) {
                this.summaryNextButton = this.page.navigationButtons[nextIndex] as PageJumpButton;
                this.page.navigationButtons.splice(nextIndex, 1);
                //if the last place we were was the summary, don't want the summary going back to the summary ad infinitum
                if (this.currentSectionIndex === lastNavigation.section && this.currentPageIndex === lastNavigation.page) { 
                    resumeButton.targetPage = this.summaryNextButton.targetPage;
                }
            }
            this.page.navigationButtons.push(resumeButton);
        } else {
            this.returningUser = false;
        }
    }
    
    reinstateSummaryNextButton(): void {
        if (this.page.pageType === PageType.Summary && this.summaryNextButton !== undefined) {
            let nextIndex = this.page.navigationButtons.findIndex(b => b.type === ButtonKind.JumpToPage && b.position === ButtonPosition.Right);
            if (nextIndex !== -1) {
                this.page.navigationButtons.splice(nextIndex, 1);
                this.page.navigationButtons.push(this.summaryNextButton);
            }
        }
    }

    public showBackButton(button): boolean {
        return (this.page.pageType !== PageType.Summary && button.position === ButtonPosition.Left && button.visible());
    }

    public showNextButton(button): boolean {
        return (button.position === ButtonPosition.Right && button.visible());
    }

    public toggleAdhoc(status: boolean): void {
        this.addAdhoc = status;
    }

    get user(): UserIdentity {
        return this.authService.User;
    }

    public isButtonDisabled(button: Button): boolean {
        if (button.alwaysEnable === true) return false;
        let result: boolean = (typeof button.enabled === "function" && !button.enabled());
        if (result == false) { //separating out logic for flow-defined button rule and rules by type, to allow type rules to override a flow-defined button rule
            if (button.isApprove) {
                let completedReviews = this.workflow.associatedWorkItems.filter(w => (w.type === WorkOrderType.Review || w.type === WorkOrderType.ReviewExpedite || w.type === WorkOrderType.AdHocReview) && w.status === WorkOrderStatus.Completed);
                if (completedReviews.length === 0) {
                    result = (this.flowForm) ? !this.flowForm.valid : false; //no reviews have been completed yet, so anyone who can get this far ought to be able to review; decide enabling based on Transition criteria
                } else {
                    //evaluate the completed review's transitions against the current review's transition.  Current user can't approve if they're on a previous completed review, and the current review targets a different transition
                    let buttonTargetTransition = this.workflow.associatedWorkItems.find(w => w.id === this.workItemId).transition;
                    let differentReviews = completedReviews.filter(w => w.transition != buttonTargetTransition && w.transitionName != 'Send to Review');  //exclude 'completion' reviews from this match
                    result = (differentReviews.filter(w => w.lastUpdatedUserId == this.authService.User.id).length > 0) ||
                        (this.flowForm ? this.flowForm.invalid : false); //disabled if any of the other completed reviews were completed by the current user, or if the form is invalid, as previously with Transition criteria
                }
            } else if (button.isTransition) {
                result = (this.flowForm) ? !this.flowForm.valid : false;
            } else if (this.ngForm.disabled && !button.isSpecial && this.state.stateType === StateType.ReviewForm) {
                result = false;
            } else {
                result = (this.ngForm) ? this.ngForm.invalid : false;
            }
        }

        return result;
    }

    private restrictButtonAccess(button: Button): boolean {
        if (this.authService.User.isInternal) return false;
        if (button.restrictingGroups == null || button.restrictingGroups.length === 0) return false;
        return button.restrictingGroups.findIndex(r => this.authService.User.groups.includes(r)) === -1;
    }

    public forbid(message: string): void {
        this.forbiddenDialog.message = message;
        this.forbiddenDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.forbiddenDialog);
    }

    public notify(message: string): void {
        this.notifyDialog.message = message;
        this.notifyDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.notifyDialog);
    }

    public notifyComplete(message: string): void {
        this.completeDialog.message = message;
        this.completeDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.completeDialog);
    }

    confirmButtonAction(): void {
        this.buttonAction(this.clickedButton);
    }

    missingInformationContinue(): void {
        this.goToPage(this.clickedButton);
    }

    onComplete(): void {
        if (this.url.length > 0) {
            this.router.navigate([this.url]);
        } else {
            this.router.navigate(["/home"]);
        }
    }

    routeForbidden(): void {
        this.router.navigate(["/home"]);
    }

    public onDialogClose(): void {
      
    }

}
